export const validate = values => {
  const required = 'Required';
  const errors = {};
  if (!values.note) {
    errors.note = required
  }
  return errors
};
